import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../api/endpoints';
import PageHeader from '../../components/PageHeader';
import { Button, Empty, Loading, Row } from '../../components/Ui';
import { currency, shortDate } from '../../utils/format';

/** Everything ever done to one bike: dates, km, parts, bills and workshops. */
const ServiceHistoryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    api.garage.history(id)
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [id]);
  useEffect(load, [load]);

  if (loading) return <Loading text="Loading history…" />;
  if (!data) return <Empty emoji="📚" title="Nothing here" />;

  const { vehicle, jobs } = data;

  return (
    <div style={{ maxWidth: 820 }}>
      <PageHeader
        title="Service history"
        subtitle={`${vehicle.brand} ${vehicle.model} · ${vehicle.currentKm} km`}
        back
      />

      {vehicle.nextServiceAt ? (
        <div className="card sh-sm" style={{ borderColor: 'var(--primary)', marginBottom: 16 }}>
          <div className="t-title">Next service</div>
          <div className="t-small">
            {shortDate(vehicle.nextServiceAt)} or at {vehicle.nextServiceKm} km, whichever comes first.
          </div>
          <div style={{ marginTop: 10 }}>
            <Button title="Book it now" size="sm" onClick={() => navigate('/bike-service/book')} />
          </div>
        </div>
      ) : null}

      {!jobs.length ? (
        <Empty emoji="📚" title="No services yet" text="Once a service is delivered it is recorded here with its bill." />
      ) : jobs.map((item) => (
        <div className="card sh-sm" key={item._id} style={{ marginBottom: 12 }}>
          <div className="t-title">{shortDate(item.updatedAt)} · {item.vehicleInfo && item.vehicleInfo.km} km</div>
          <div className="t-small">{item.services.map((s) => s.title).join(', ')}</div>
          {(item.partsUsed || []).length ? (
            <div className="t-tiny">Parts: {item.partsUsed.map((p) => `${p.name} ×${p.qty}`).join(', ')}</div>
          ) : null}
          <Row label="Bill" value={currency((item.bill && item.bill.total) || 0)} />
          {item.invoiceNo ? <Row label="Invoice" value={item.invoiceNo} /> : null}
          {item.partner ? <Row label="Workshop" value={item.partner.businessName} /> : null}
          <button type="button" className="link-btn" onClick={() => navigate(`/service-jobs/${item._id}`)}>See the full job</button>
        </div>
      ))}
    </div>
  );
};

export default ServiceHistoryPage;
